<template>
    <auth-layout pageClass="login-page">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-4 col-md-6 col-sm-8">
                <form method="#" action="#">
                    <fade-render-transition>
                        <card>
                            <div slot="header">
                                <h3 class="card-title text-center"><img src="static/img/Numier-logo-HORIZONTAL.png"/>
                                </h3>
                            </div>
                            <div class="card-login">
                                <fg-input :label="$t('email')"
                                          :placeholder="$t('introduzcaEmail')"
                                          type="email"
                                          v-model="email">

                                </fg-input>

                                <div>
                                    <small>
                                        <span class="fa fa-info-circle"></span>
                                        {{$t('paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros')}} <a
                                            href="mailto:info@numier.com">info@numier.com</a>
                                    </small>
                                </div>

                                <div v-if="errorLogin">
                                    <div class="alert alert-danger" role="alert">{{errorTextLogin}}</div>
                                </div>

                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-fill btn-info btn-round btn-wd"
                                        @click.prevent="login">
                                    {{$t('obtenerContrasena')}}
                                </button>
                                <br>
                            </div>
                        </card>
                    </fade-render-transition>

                </form>
            </div>
        </div>
    </auth-layout>
</template>
<script>
    import {Checkbox as LCheckbox, FadeRenderTransition} from 'src/components/index'
    import AuthLayout from './AuthLayout.vue'

    export default {
        components: {
            LCheckbox,
            FadeRenderTransition,
            AuthLayout
        },
        data() {
            return {
                email: '',
                pass: '',
                remember: true,
                errorLogin: false,
                errorTextLogin: ""
            }
        },
        methods: {
            login() {
                this.checkInputs();
                if (!this.errorLogin) {
                    let vm = this
                    this.axios.post(this.$store.getters.apiUrl + "login", {
                        email: this.email,
                        pass: this.pass
                    }).then(function (response) {
                        if (response.data.response) {

                            vm.$store.dispatch("setJWT", response.data.result);
                            if (vm.remember) {
                                var date = new Date;
                                date.setDate(date.getDate() + 21);
                                vm.$cookie.set('jwt', response.data.result, {expires: date});
                            }

                            // vm.$store.dispatch('fetchBusiness');
                            vm.$router.push("/");
                            /* vm.terms();*/
                        } else {
                            this.errorLogin = true;
                            this.errorTextLogin = response.data.message;
                        }
                    }).catch(function (error) {
                        vm.errorLogin = true;
                        vm.errorTextLogin = vm.$t('haHabidoUnErrorAlConectarPruebeDeNuevo');
                        console.log(error);
                    });
                }
            },
            /*terms() {
                this.checkInputs();
                if (!this.errorLogin) {
                    let vm = this
                    this.axios.post(this.$store.getters.apiUrl + "terms", {
                        email: this.email
                    }).then(function (response) {
                        if (response.data.response) {

                            if (response.data.result == 0) {
                                vm.$router.push("/terms");
                            } else {
                                vm.$router.push("/");
                            }
                        } else {
                            this.errorLogin = true;
                            this.errorTextLogin = response.data.message;
                        }
                    }).catch(function (error) {
                        vm.errorLogin = true;
                        vm.errorTextLogin = "Ha habido un error al conectar. Pruebe de nuevo";
                        console.log(error);
                    });
                }
            },*/
            checkInputs() {
                if (this.email == "") {
                    this.errorLogin = true;
                    this.errorTextLogin = this.$t('elEmailNoPuedeEstarEnBlanco');
                    return;
                }

                if (!this.validateEmail(this.email)) {
                    this.errorLogin = true;
                    this.errorTextLogin = this.$t('elEmailNoEsValido');
                    return;
                }

                if (this.pass == "") {
                    this.errorLogin = true;
                    this.errorTextLogin = this.$t('laContrasenaNoPuedeEstarEnBlanco');
                    return;
                }

                this.errorLogin = false;
                this.errorTextLogin = "";
            },
            validateEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            toggleNavbar() {
                document.body.classList.toggle('nav-open')
            },
            closeMenu() {
                document.body.classList.remove('nav-open')
                document.body.classList.remove('off-canvas-sidebar')
            },
        },
        beforeDestroy() {
            this.closeMenu()
        }
    }
</script>
<style scoped>
    .navbar-nav .nav-item p {
        line-height: inherit;
        margin-left: 5px;
    }

    .card-login {
        padding: 10px 20px;
    }

    .checkRemember {
        cursor: pointer;
    }

    @media (max-width: 768px) {

        .form-group {
            margin-bottom: 0px;
        }

        .card {
            padding-top: 10px;
        }

        img {
            width: 200px;
        }

        .content {
            padding-top: 15px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/GeneralViews/RememberPass.vue